export default "__VITE_PUBLIC_ASSET__edb14768__"